export const EXPAND_RISK = {
  SHOW: 'showRisk',
  INFO: 'showRiskInfo',
  DEFAULT: 'default',
  MINOR: 'minor',
  ADULT: 'adult',
};
export const IDD_CHECK = {
  TRUE: 'Oui',
  FALSE: 'Non',
};
export const DEDUCTION_NO_RATE_IDD = 100;
export const DEDUCTION_RATE_IDD = 0;

export const RELIQUAT_JUGEMENT = '2751';
export const PARTIAL_JUGEMENT = '2750';
export const TOTAL_JUGEMENT = '2752';
export const RELIQUAT_JUGEMENT_TITLE = 'Reliquat jugement';

export const RELIQUAT_APPEL = '2753';
export const VICTIME_TYPES = {
  MINEURE_BLESSEE: 'Victimes blessées',
  MAJEURE_BLESSEE: 'Victimes blessées',
  DECEDEE_VICTIME: 'Victimes décédées',
};
